import { useState } from "react";
import ApprovalDetail from "@/components/ApprovalDetail";
import { Pill, Table } from "@/components/common";

export function ApprovalQueue({ items, onChange, testid = "approval-queue", empty = "No items awaiting your decision" }) {
  const [open, setOpen] = useState(null);
  const cols = [
    { k: "title", h: "Item", r: (a) => <button data-testid={`approval-row-${a.id}`} onClick={() => setOpen(a.id)} className="text-left font-medium text-indigo-700 hover:underline">{a.title}</button> },
    { k: "project_code", h: "Project" },
    { k: "item_type", h: "Type", r: (a) => <Pill>{a.item_type}</Pill> },
    { k: "current_level", h: "Current step" },
    { k: "requester_name", h: "Raised by" },
    { k: "age", h: "Age (wd)", r: (a) => <span className={a.step_age_days >= 5 ? "font-semibold text-red-600" : a.step_age_days >= 3 ? "text-amber-600" : ""}>{a.step_age_days}</span> },
    { k: "status", h: "Status", r: (a) => <Pill tone={a.status === "approved" ? "green" : a.status === "rejected" ? "red" : "amber"}>{a.status}</Pill> },
  ];
  return (
    <>
      <Table cols={cols} rows={items || []} testid={testid} empty={empty} />
      <ApprovalDetail id={open} onClose={() => setOpen(null)} onDone={onChange} />
    </>
  );
}
